import React from "react";
import banner1 from "../../../images/projects/1.webp";
import banner2 from "../../../images/projects/2.webp";
import banner3 from "../../../images/projects/3.webp";
import banner4 from "../../../images/projects/4.webp";
import banner5 from "../../../images/projects/5.webp";
import banner6 from "../../../images/projects/6.webp";
import "./Projects.css";

function Projects() {
  return (
    <div id="rs-portfolio" className=" bg42 pb-5 mb-3">
      <div className="" style={{ width: "90%", margin: "auto" }}>
        <div className="sec-title4 text-center p-5">
          <h2 className="title white-color">Recent Portfolios</h2>
        </div>
        <div className="slider-part">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12 portfolio-wrap">
              <div className="img-part">
                <img src={banner1} className="images" alt="" />
                <div className="content-part">
                  <div className="text"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 portfolio-wrap">
              <div className="img-part">
                <img src={banner2} className="images" alt="" />
                <div className="content-part">
                  <div className="text"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 portfolio-wrap">
              <div className="img-part">
                <img src={banner3} className="images" alt="" />
                <div className="content-part">
                  <div className="text"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 portfolio-wrap">
              <div className="img-part">
                <img src={banner4} className="images" alt="" />
                <div className="content-part">
                  <div className="text"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 portfolio-wrap">
              <div className="img-part">
                <img src={banner5} className="images" alt="" />
                <div className="content-part">
                  <div className="text"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 portfolio-wrap">
              <div className="img-part">
                <img src={banner6} className="images" alt="" />
                <div className="content-part">
                  <div className="text"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
